import { ApiService } from 'services';

import { getOnlineConfig, getAuthState, redirectToApi } from 'actions';

// eslint-disable-next-line import/prefer-default-export
export function saveSitePreload(json, isProtectedUrl, confirmAuthState, authentalinkRedirectPath) {
  return (dispatch) => {
    ApiService.saveWebAppConfig(json);
    let promise = null;

    if (authentalinkRedirectPath) {
      redirectToApi(authentalinkRedirectPath);
      return promise;
    }

    if (isProtectedUrl) {
      promise = dispatch(getOnlineConfig());
    }
    if (confirmAuthState) {
      promise = dispatch(getAuthState());
    }
    return promise;
  };
}
